<button
  type="button"
  class="esn-filter-chip"
  [class.esn-filter-chip--active]="selected()"
  [attr.aria-pressed]="selected()"
  [attr.data-direction]="kind() === 'sort' ? direction() : null"
  (click)="handleClick($event)"
>
  <ng-content />
  @if (kind() === 'sort') {
    <esn-icon class="esn-filter-chip__icon esn-filter-chip__icon--sort" name="sort" [size]="20" />
  } @else {
    <esn-icon class="esn-filter-chip__icon" name="chevron-down" [size]="12" />
  }
</button>
